"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalType = exports.createSignal = void 0;
function createSignal(name) {
    return new SignalType(name);
}
exports.createSignal = createSignal;
// empty class is needed to save the generic type so typescript can infer it later
class SignalType {
    constructor(name) {
        this.name = name;
    }
}
exports.SignalType = SignalType;
//# sourceMappingURL=signals.js.map